export default "__VITE_ASSET__V1ZYpwZc9C51fJhgOTS5xQ__ 480w, __VITE_ASSET__HAwZnQ40A17rYC3Q$lxt9A__ 768w, __VITE_ASSET__cLLFq7OX38PQjR0WE41fig__ 1200w";